const MAX_VISIBLE_ITEMS = 5;

const hideItems = (items) => {
  items.forEach((item) => {
    item.style.display = 'none';
  });
};

const showItems = (items) => {
  items.forEach((item) => {
    item.style.display = '';
  });
};

const getOrCreateToggleButton = (group) => {
  let button = group.querySelector('.view-all');

  if (!button) {
    button = document.createElement('button');
    button.type = 'button';
    button.classList.add('view-all');
    button.textContent = 'View All';
    group.appendChild(button);
  }

  button.type = 'button';
  button.setAttribute('aria-expanded', 'false');

  return button;
};

export const initFilterMultiOptions = () => {
  const optionGroups = document.querySelectorAll('.filter-multi-options .option-group');

  if (!optionGroups.length) return;

  optionGroups.forEach((group) => {
    const optionItems = Array.from(group.querySelectorAll('.option-item'));

    if (optionItems.length <= MAX_VISIBLE_ITEMS) {
      const existingButton = group.querySelector('.view-all');
      if (existingButton) existingButton.remove();
      return;
    }

    const hiddenItems = optionItems.slice(MAX_VISIBLE_ITEMS);
    hideItems(hiddenItems);

    const toggleButton = getOrCreateToggleButton(group);

    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();

      const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        hideItems(hiddenItems);
        toggleButton.textContent = 'View All';
        toggleButton.setAttribute('aria-expanded', 'false');
      } else {
        showItems(hiddenItems);
        toggleButton.textContent = 'Close';
        toggleButton.setAttribute('aria-expanded', 'true');
      }
    });
  });
};
